<div fxLayout="column">
  <app-page-header
    [description]="'We will use your billing information to invoice you for your monthly lease and transactional fees. We require your banking details to process your Point of Sale payments to you.'"
    [section]="'Billing and Banking'"
    [title]="'Manage your billing and banking details'">
  </app-page-header>

  <div fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="10px"
       class="page-content page-padding full-screen-height-page-default full-width">
    <app-info-panel
      message="You can update your billing & banking information at any time. Please note that BOTH must be populated for payouts to occur."
      [type]="'info'"></app-info-panel>

    @if (showCapitecWarning) {
      <app-info-panel
        message="You have selected Capitec Bank. If the account type is 'Capitec Business Account', please select 'Capitec Business Banking' instead."
        [type]="'warn'"></app-info-panel>
    }

    <div class="full-width" fxLayout="column" fxLayout.gt-sm="row"
         fxFlexOffset="30px" fxLayoutGap="20px">

      <app-banking-details [(editing)]="editing" (capitecWarning)="showCapitecWarning = $event"
                           fxFlex="50"></app-banking-details>

      <div class="section-divider" fxHide.gt-sm>
        <mat-divider></mat-divider>
      </div>

      <app-billing-details [(editing)]="editing" fxFlex="50"></app-billing-details>
    </div>
  </div>

</div>
